































import {
  ImageSize,
  OrderType,
  SpaceType,
} from '@/resource/question/question.type';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class AddQuestionInfo extends Vue {
  spaceTypes = Object.keys(SpaceType);
  orderTypes = Object.keys(OrderType);
  imageSizes = Object.keys(ImageSize);
}
